import { render } from "./departments-settings.vue?vue&type=template&id=10cc2756"
import script from "./departments-settings.vue?vue&type=script&lang=js"
export * from "./departments-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__